var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7872 9.66088C21.6518 9.78145 21.4681 9.85035 21.2747 9.85035C20.559 9.85035 19.9787 10.3671 19.9787 10.9958C19.9787 11.6288 20.5522 12.1429 21.2611 12.1498C21.6605 12.1533 22 12.4013 22 12.757V14.966C22 16.8254 20.3075 18.3334 18.2186 18.3334H15.0658C14.7398 18.3334 14.4758 18.0983 14.4758 17.8081V15.9478C14.4758 15.5861 14.1567 15.3019 13.7505 15.3019C13.354 15.3019 13.0251 15.5861 13.0251 15.9478V17.8081C13.0251 18.0983 12.7611 18.3334 12.4362 18.3334H5.78143C3.70213 18.3334 2 16.8263 2 14.966V12.757C2 12.4013 2.33946 12.1533 2.73888 12.1498C3.44874 12.1429 4.02128 11.6288 4.02128 10.9958C4.02128 10.3843 3.46035 9.91924 2.72534 9.91924C2.53191 9.91924 2.34816 9.85035 2.21277 9.72977C2.07737 9.6092 2 9.44557 2 9.27332V7.04275C2 5.18595 3.706 3.66675 5.7911 3.66675H12.4362C12.7611 3.66675 13.0251 3.90186 13.0251 4.1921V6.39683C13.0251 6.74993 13.354 7.04275 13.7505 7.04275C14.1567 7.04275 14.4758 6.74993 14.4758 6.39683V4.1921C14.4758 3.90186 14.7398 3.66675 15.0658 3.66675H18.2186C20.3075 3.66675 22 5.17389 22 7.03414V9.20443C22 9.37667 21.9226 9.5403 21.7872 9.66088ZM13.7505 13.6311C14.1567 13.6311 14.4758 13.3383 14.4758 12.9852V9.5403C14.4758 9.1872 14.1567 8.89438 13.7505 8.89438C13.354 8.89438 13.0251 9.1872 13.0251 9.5403V12.9852C13.0251 13.3383 13.354 13.6311 13.7505 13.6311Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1688:9463",
    x1: 4,
    y1: 18.3334,
    x2: 20.6067,
    y2: 2.22993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/Ticket.e90c1ff513a36ab6b82e208d0a76153b.svg";
export { ForwardRef as ReactComponent };